module.exports = __webpack_public_path__ + "img/exit.d6fd3547.png";